import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { SET_SELECTED_DATASOURCE_IDS, SET_EDITING_DATASOURCE_ID, CLEAR_SYS_GUARD_TABLE_DATA, CLEAR_SYS_GUARD_FILTERS } from "./sysGuardConstants";
import { getClassNamesByType } from "./SysGuardCommonComp";
import { statusMapping } from "./sysGuardConstants";
import { icons } from "../../components/common/utilities";

const DataSourceSelector = ({ setIsEditMode, setOpenOnBoardingForm } = {}) => {
  const dispatch = useDispatch();
  const dataSourcesById = useSelector(
    (state) => state.SysGuardReducer.sysGuardDataSource
  );
  const selectedDatasourceID = useSelector(
    (state) => state.SysGuardReducer.selectedDatasourceID
  );

  const dataSources = Object.values(dataSourcesById);

  const handleChange = (event) => {
    const value = event.target.value;
    dispatch({ type: CLEAR_SYS_GUARD_TABLE_DATA });
    dispatch({ type: CLEAR_SYS_GUARD_FILTERS });
    dispatch({
      type: SET_SELECTED_DATASOURCE_IDS,
      payload: typeof value === "string" ? value.split(",") : value,
    });
  };

  const getDataSourceIcon = (typeCode) => {
    return icons[typeCode];
  };

  return (
    <FormControl className="data-source-selector">
      <Select
        multiple
        value={selectedDatasourceID}
        onChange={handleChange}
        renderValue={(selected) => (
          <div className="selected-chips">
            {selected.map((id) => {
              const ds = dataSourcesById[id];
              return (
                <Chip
                  key={id}
                  title={ds?.domainName}
                  icon={
                    <img
                      src={getDataSourceIcon(ds?.typeCode)}
                      alt={ds?.typeName}
                      className="data-source-chip-icon"
                    />
                  }
                  label={ds?.domainName}
                  className="data-source-chip"
                  size="small"
                />
              );
            })}
          </div>
        )}
        className="data-source-select"
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          },
          getContentAnchorEl: null,
          disableAutoFocusItem: true,
          variant: "menu"
        }}
      >
        {dataSources.map((dataSource) => {
          const { iconClassName, containerClassName, title } = getClassNamesByType(
              dataSource?.typeCode
            );
          return (
          <MenuItem key={dataSource.id} value={dataSource.id} className="sysguard-ds-selector">
            <Checkbox
              checked={selectedDatasourceID.indexOf(dataSource.id) > -1}
              style={{
                color: selectedDatasourceID.indexOf(dataSource.id) > -1 ? "#47856d" : undefined,
              }}
            />
            <img
              src={getDataSourceIcon(dataSource.typeCode)}
              alt={dataSource.typeName}
              className='data-source-option-icon'
              title={dataSource.typeName}
            />
            <ListItemText primary={dataSource.domainName} />
            <div className="sys-guard-status">
              <img
                src={statusMapping[dataSource?.connectionStatus || "Error"]}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch({ type: SET_EDITING_DATASOURCE_ID, payload: dataSource.id });
                  setIsEditMode(true);
                  setOpenOnBoardingForm(true);
                }}
              />
            </div>
          </MenuItem>
        )})}
      </Select>
    </FormControl>
  );
};

export default DataSourceSelector;
